import type { VariantItemPdp } from "@/common/lib/types";

type Pricing = VariantItemPdp["pricing"];

export const isFuturePromotionPreviewPricing = (pricing?: Pricing) => {
  if (pricing?.isPreviewPrice !== true) {
    return false;
  }

  if (pricing.previewPromotion?.showBadgeInStorefront === false) {
    return false;
  }

  const startDate = pricing.previewPromotion?.startDate;

  if (!startDate) {
    return false;
  }

  const startTime = new Date(startDate).getTime();

  return !Number.isNaN(startTime) && startTime > Date.now();
};

export const getDisplayPriceAmount = (pricing?: Pricing) => {
  if (isFuturePromotionPreviewPricing(pricing)) {
    return pricing?.costPrice?.gross?.amount ?? pricing?.priceUndiscounted?.gross?.amount ?? pricing?.price?.gross?.amount ?? 0;
  }

  return pricing?.price?.gross?.amount ?? 0;
};
